import { Titles } from "./Titles";

export const Variables = [
  {
    label: Titles.TemporalVariation,
    type: "o.created_at",
  },
  {
    label: Titles.OrderQuantity,
    type: "c.count_orders",
  },
  {
    label: Titles.TotalSpent,
    type: "c.total_orders",
  },
  {
    label: Titles.DaysWithoutOrder,
    type: "c.days_without_order",
  },
  {
    label: Titles.Birthday,
    type: "c.birthdate",
  },
  {
    label: Titles.AverageTicket,
    type: "c.average_ticket",
  },
  {
    label: Titles.OrderValue,
    type: "o.order_total",
  },
  {
    label: Titles.Age,
    type: "c.age",
  },
  {
    label: Titles.CustomerName,
    type: "c.name",
  },
  {
    label: Titles.CustomerEmail,
    type: "c.email",
  },
  {
    label: Titles.CustomerPhone,
    type: "c.phone",
  },
  {
    label: Titles.CustomerDoc,
    type: "c.doc",
  },
  {
    label: Titles.RfvFrequency,
    type: "c.rfv_frequency",
  },
  {
    label: Titles.CustomerCreatedAt,
    type: "c.created_at",
  }
];
